import { ADMIN_USERS_ENDPOINTS, AdminUsersService } from "@/service/api/admin-users";
import { ListAdminUsersDto } from "@/service/dto/admin-users";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "react-toastify";

const useUsersList = (params: ListAdminUsersDto) => {
  const query = useQuery({
    queryKey: [ADMIN_USERS_ENDPOINTS.GET_USERS, params],
    queryFn: () => AdminUsersService.getUsers(params),
    placeholderData: keepPreviousData,
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      toast.error(query.error?.message || "Erro ao carregar usuários.");
    }
  }, [query.isError, query.error]);

  return query;
};

export default useUsersList;
